$(document).ready(function () {
  var wistiaPlayed = false

  // LEARN MORE onclick event located in hero of most landing pages
  $(".hero-learn-more").on("click", function () {
    var ele = $(this).closest("section").next("section")
    $("html, body").animate(
      {
        scrollTop: $(ele).offset().top - 120,
      },
      1000,
    )
    return false
  })

  $(".demo-modal").on("click tap", function () {
    $("#book-demo, .overlay, .bkgnd-overlay").removeClass("hide")
    if ($(".yellow.box")) {
      $(".yellow.box").removeClass("hide")
    }
    animateTo("#book-demo")
  })

  $("#book-demo .close, .bkgnd-overlay").on("click tap", function () {
    $("#book-demo, .overlay, .bkgnd-overlay").addClass("hide")
    if ($(".yellow.box")) {
      $(".yellow.box").addClass("hide")
    }
  })
  var url = window.location.href
  // Autoplay video if coming from Welcome Email
  if (url.match("utm_content=play")) {
    $(".video-container").removeClass("hide").addClass("show")
    $(".bkgnd-overlay").removeClass("hide").addClass("show")
    $("html, body").animate(
      {
        scrollTop: $(".video-container").offset().top - 120,
      },
      1000,
    )
  }
  // play button action
  $(".play").on("click tap", function () {
    $(".video-container").removeClass("hide").addClass("show")
    $(".bkgnd-overlay").last().removeClass("hide").addClass("show")
  })

  // close button action
  $(".video-container .close").on("click tap", function () {
    $(".video-container").removeClass("show").addClass("hide")
    $(".bkgnd-overlay").removeClass("show").addClass("hide")
  })

  $(".bkgnd-overlay").on("click tap", function () {
    $(".video-container").removeClass("show").addClass("hide")
    $(this).removeClass("show").addClass("hide")
  })

  // Performance Diagnostic LP
  //on video end, close itself
  window._wq = window._wq || []
  window._wq.push({
    id: "4sqbb68pad",
    onHasData: function (video) {
      video.bind("end", function () {
        $(".video-container")
          .delay(800)
          .fadeOut("slow")
          .removeClass("show")
          .addClass("hide")
        $(".bkgnd-overlay").removeClass("show").addClass("hide")
        //return video.unbind;
      })
    },
  })

  //Black Lives Matter LP
  var blmColumn = document.querySelector(".blm-one-column-narrow-width")
  var expandContentLink = blmColumn.querySelector(
    ".blm-one-column-narrow-width .cta",
  )
  var expandedContent = document.querySelector(".header__expanded-content")
  var shrinkContentLink = expandedContent.querySelector(
    ".header__expanded-content-cta",
  )
  var contentShrunk = true

  expandContentLink.addEventListener("click", expandContent)
  shrinkContentLink.addEventListener("click", expandContent)

  function expandContent(e) {
    e.preventDefault()

    if (contentShrunk) {
      expandedContent.classList.remove("hide")
      expandContentLink.classList.add("hide")
      shrinkContentLink.classList.remove("hide")
      blmColumn.classList.add("blm-one-column-narrow-width--expanded")
      contentShrunk = false
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
      expandedContent.classList.add("hide")
      expandContentLink.classList.remove("hide")
      shrinkContentLink.classList.add("hide")
      blmColumn.classList.remove("blm-one-column-narrow-width--expanded")
      contentShrunk = true
    }
  }

  function closeVideoOverlay() {
    $(".video-container").addClass("hide")
    $(".bkgnd-overlay").addClass("hide")
  }

  function loadWistiaVideo(e) {
    var videoID = e.currentTarget.dataset.videoId
    var videoContainer = document.querySelector(".video-container")

    if (!wistiaPlayed) {
      wistiaPlayed = true

      // inject Wistia scripts
      var scriptElement = document.createElement("script")
      scriptElement.src = "//fast.wistia.com/embed/medias/" + videoID + ".jsonp"
      scriptElement.type = "text/javascript"
      document.getElementsByTagName("head")[0].appendChild(scriptElement)

      var scriptElement = document.createElement("script")
      scriptElement.src = "//fast.wistia.com/assets/external/E-v1.js"
      scriptElement.type = "text/javascript"
      document.getElementsByTagName("head")[0].appendChild(scriptElement)
    }

    // embed the wistia video
    var html =
      '<div class="wistia_embed wistia_async_' +
      videoID +
      '" style="width:100%;">&nbsp;</div>'
    videoContainer.querySelector(".video-container__content-embed").innerHTML =
      html

    window._wq = window._wq || []
    _wq.push({
      id: videoID,
      options: {
        videoFoam: true,
        autoPlay: true,
        seo: false,
      },
    })

    videoContainer.classList.add("show")
    videoContainer.classList.remove("hide")
    videoContainer.nextElementSibling.classList.remove("hide")
  }

  var loadWistiaButton = document.querySelector(".btn-wistia")

  if (loadWistiaButton) {
    loadWistiaButton.addEventListener("click", loadWistiaVideo)

    // close when escape is pressed
    document.addEventListener("keydown", function (e) {
      if (e.which == 27) {
        closeVideoOverlay()
      }
    })
  }
})

function animateTo(target) {
  var isTablet = window.matchMedia("(min-width: 768px) and (max-width: 1024px)")
  var isMobileTab = window.matchMedia(
    "(min-width: 381px) and (max-width: 767px)",
  )
  var isMobile = window.matchMedia("(min-width: 322px) and (max-width: 380px)")
  var isMobileSmall = window.matchMedia("(max-width: 321px)")

  if (isTablet.matches) {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 90,
      },
      1200,
    )
    $(".wp-block-column").has(".show").toggleClass("adjust-top")
  } else if (isMobileTab.matches) {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 50,
      },
      1200,
    )
  } else if (isMobile.matches) {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 15,
      },
      1200,
    )
  } else if (isMobileSmall.matches) {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 5,
      },
      1200,
    )
  } else {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 25,
      },
      1200,
    )
  }
}

// ALLI FORM FUNCTIONS
var flashMessage =
  '<div class="alert alert-warning"><span>Please email our support team directly at <a href="mailto:support@cultureamp.com" target="_blank" rel="noopener noreferrer">support@cultureamp.com</a></span></div>'
var click = 0

function hitMe() {
  if (click == 0) {
    $('input[value="Product Support"]').closest("li").after(flashMessage)
    click++
  } else {
    $(".alert-warning").remove()
    click--
  }
}
